import api from './api';

export const notificationService = {
  getNotifications: async () => {
    const response = await api.get('/notifications');
    return response.data?.data || [];
  },

  getUnreadCount: async () => {
    try {
      const response = await api.get('/notifications/unread/count');
      return response.data?.unreadCount ?? 0;
    } catch (error) {
      // If the user is not authorized or the endpoint fails, treat as 0
      if (error.response?.status === 401) {
        return 0;
      }
      throw error;
    }
  },

  markAllRead: async () => {
    await api.put('/notifications/read-all');
  },

  markRead: async (id) => {
    await api.put(`/notifications/${id}/read`);
  },

  markUnread: async (id) => {
    await api.put(`/notifications/${id}/unread`);
  },

  clearAll: async () => {
    await api.delete('/notifications/clear');
  },
};
